<!-- Wrapper do autocomplete com icones internos -->
<div class="entity-ac-wrapper">
  <p-autoComplete #autoCompleteRef
    class="entity-autocomplete"
    [(ngModel)]="autoCompleteValue"
    [suggestions]="filteredEntities"
    (completeMethod)="onAutoComplete($event)"
    (onSelect)="onEntitySelect($event)"
    (onClear)="onClear()"
    [field]="'nome'"
    [placeholder]="config.placeholder"
    [minLength]="0"
    [delay]="0"
    [completeOnFocus]="true"
    [forceSelection]="false"
    [showEmptyMessage]="true"
    [emptyMessage]="config.emptyMessage || ('entity-selector.spans.nenhum_encontrado' | translate)"
    [disabled]="disabled"
    styleClass="w-full"
    inputStyleClass="w-full entity-ac-input-icons"
    [panelStyleClass]="panelStyleClass"
    [scrollHeight]="'400px'"
    appendTo="body">

    <!-- Template de item no dropdown do autocomplete -->
    <ng-template let-entity pTemplate="item">
      <div class="entity-ac-item">
        <div class="entity-ac-avatar">
          <i class="pi pi-user"></i>
        </div>
        <div class="entity-ac-id">{{ entity.codigoPessoa }}</div>
        <div class="entity-ac-info">
          <span class="entity-ac-nome">{{ entity.nome }}</span>
          <span *ngIf="entity.fantasia" class="entity-ac-fantasia">{{ entity.fantasia }}</span>
        </div>
      </div>
    </ng-template>

    <!-- Botao "+ Agregar Persona" fixo no footer do dropdown -->
    <ng-template *ngIf="config.showAddInDropdown" pTemplate="footer">
      <div class="entity-ac-add-item entity-ac-add-footer" (click)="onAddNewFromDropdown($event)">
        <div class="entity-ac-add-icon">
          <i class="pi pi-plus"></i>
        </div>
        <span class="entity-ac-add-label">{{ addNewLabel }}</span>
      </div>
    </ng-template>
  </p-autoComplete>

  <!-- Icones dentro do input (clear + search/lupa) -->
  <div class="entity-ac-icons">
    <i *ngIf="autoCompleteValue && !disabled"
       class="pi pi-times entity-ac-icon-clear"
       (click)="clear()"></i>
    <i class="pi pi-search entity-ac-icon-search"
       [class.disabled]="disabled"
       (click)="!disabled && openDialog()"></i>
  </div>
</div>

<!-- Botao "+" (opcional) -->
<button *ngIf="config.showAddButton"
  pButton icon="pi pi-plus"
  class="action-button"
  [disabled]="disabled"
  (click)="addNew.emit()"
  [pTooltip]="config.addButtonTooltip || ''"
  tooltipPosition="left">
</button>

<!-- Dialog de selecao -->
<p-dialog
  [(visible)]="dialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '95vw', maxWidth: '1400px', height: '98vh' }"
  [contentStyle]="{ 'height': '100%', 'overflow': 'hidden', 'display': 'flex', 'flex-direction': 'column' }">

  <!-- Wave header -->
  <div class="dialog-wave-header dialog-wave-header--info ps-header-compact">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i [class]="config.dialogIcon || 'pi pi-users'" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ config.dialogTitle || ('entity-selector.texts.selecionar' | translate) }}</h2>
        <p *ngIf="config.dialogSubtitle">{{ config.dialogSubtitle }}</p>
      </div>
    </div>
    <button pButton icon="pi pi-times" class="p-button-rounded p-button-text ps-btn-fechar"
      (click)="closeDialog()"></button>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 20" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,10 C150,20 350,0 500,10 C650,20 850,0 1000,10 C1100,16 1150,10 1200,10 L1200,20 L0,20 Z" fill="white"/>
    </svg>
  </div>

  <!-- Corpo: layout ps-tabela-busca -->
  <div class="dialog-wave-body">
    <div class="ps-tabela-busca ps-tabela-fullheight">

      <!-- Busca global -->
      <div class="ps-busca-global">
        <div class="ps-busca-input-wrapper">
          <i class="pi pi-search ps-busca-icone"></i>
          <input #buscaInput pInputText type="text" class="w-full ps-busca-input"
            [(ngModel)]="searchNome"
            [placeholder]="'entity-selector.placeholders.buscar' | translate"
            (keyup)="onSearchKeyUp($event)" />
        </div>
        <button *ngIf="config.showAddButton || config.showAddInDropdown" pButton type="button" icon="pi pi-plus"
          class="p-button-success es-add-btn"
          [label]="config.addButtonTooltip || ('entity-selector.buttons.agregar_persona' | translate)"
          (click)="onAddNewFromDialog()"></button>
      </div>

      <!-- Info de registros e paginacao superior -->
      <div class="ps-tabela-info">
        <span class="ps-registros-info">
          {{ 'entity-selector.texts.pagina' | translate }} {{ paginaAtual + 1 }}/{{ totalPaginas || 1 }}
          <span class="ml-3 text-500">{{ totalRecords }} {{ 'entity-selector.texts.registros' | translate }}</span>
        </span>
        <div class="ps-paginacao-top">
          <button pButton icon="pi pi-angle-double-left" class="p-button-text p-button-sm"
            [disabled]="paginaAtual === 0" (click)="irParaPagina(0)"></button>
          <button pButton icon="pi pi-angle-left" class="p-button-text p-button-sm"
            [disabled]="paginaAtual === 0" (click)="irParaPagina(paginaAtual - 1)"></button>
          <button pButton icon="pi pi-angle-right" class="p-button-text p-button-sm"
            [disabled]="paginaAtual >= totalPaginas - 1" (click)="irParaPagina(paginaAtual + 1)"></button>
          <button pButton icon="pi pi-angle-double-right" class="p-button-text p-button-sm"
            [disabled]="paginaAtual >= totalPaginas - 1" (click)="irParaPagina(totalPaginas - 1)"></button>
          <p-dropdown [options]="opcoesLinhasPorPagina" [(ngModel)]="rows"
            (onChange)="onLinhasPorPaginaChange()"
            [style]="{ 'min-width': '70px' }"></p-dropdown>
        </div>
      </div>

      <!-- Tabela server-side -->
      <div class="ps-tabela-container">
        <p-table [value]="entities" [loading]="loading" selectionMode="single"
          [(selection)]="selectedPessoa"
          (onRowSelect)="onRowSelect($event)"
          [scrollable]="true" scrollHeight="400px"
          [tableStyle]="{ 'min-width': '800px' }"
          styleClass="p-datatable-sm p-datatable-striped"
          (sortFunction)="customSort($event)" [customSort]="true" dataKey="id">

          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let col of columns"
                [pSortableColumn]="col.sortable !== false ? col.field : undefined"
                [style.width]="col.width || 'auto'"
                style="white-space: nowrap">
                {{ col.header }}
                <p-sortIcon *ngIf="col.sortable !== false" [field]="col.field"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-entity>
            <tr [pSelectableRow]="entity"
              [class.row-selecionado]="selectedPessoa?.id === entity.id"
              (dblclick)="onRowDblClick(entity)">
              <td *ngFor="let col of columns"
                [style.width]="col.width || 'auto'">
                {{ resolveField(entity, col.field) }}
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="columns.length" class="text-center p-4 text-500">
                {{ config.emptyMessage || ('entity-selector.texts.nenhum_encontrado' | translate) }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <!-- Rodape com botoes -->
      <div class="ps-tabela-footer">
        <span class="ps-registros-info"></span>
        <div class="ps-footer-actions">
          <button pButton
            [label]="('entity-selector.buttons.cancelar' | translate) + ' (Esc)'"
            class="p-button-text p-button-secondary"
            (click)="closeDialog()"></button>
          <button pButton icon="pi pi-check"
            [label]="('entity-selector.buttons.selecionar' | translate) + ' (Enter)'"
            class="p-button-primary"
            [disabled]="!selectedPessoa"
            (click)="confirmarSelecao()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
